import { render } from "./CustomerPage.vue?vue&type=template&id=1c67ade4&ts=true"
import script from "./CustomerPage.vue?vue&type=script&lang=ts"
export * from "./CustomerPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__